export enum ScheduleStatus {
  NotStarted,
  Started,
  Ended,
}

export type ScheduleBaseDetails = {
  scheduleId: Guid
  title: string
  isPastEvent: boolean
  status: ScheduleStatus
  createdDate: DateTime
  updatedDate: DateTime
  startDate: DateTime
  endDate: DateTime
  eventUrl: string
  timeZone: TimeZone
  updatedBy: string
  duration: string
  numberOfParticipants: number
  numberOfTasks: number
  description: string | null
  canDownloadRecording: boolean
}

export enum VirtualEventTaskType {
  URL,
  File,
  Survey,
  RapidElearning,
  Elearning,
  CesDetailed,
  CesStcw,
  CesCST,
}

export type EventUserTask = {
  id: string
  name: string
  type: VirtualEventTaskType
  isPostEvent: boolean
  isRequired: boolean
  isCompleted: boolean
  referenceId?: string
  url?: string
}

export type RecordingItem = {
  name: string
  url: string
}

export type LaunchEventDetails = {
  eventUrl: string
  exitUrl: string
}
